export enum ImageName {
    alarm = "alarm",
    alarmWarning = "alarmWarning",
    alarmWarning15 = "alarmWarning15",
    alarmWarning30 = "alarmWarning30",
    alarmWarning60 = "alarmWarning60",
    alertEquipment = "alertEquipment",
    alertEquipmentNotification = "alertEquipmentNotification",
    alertEquipmentError = "alertEquipmentError",
    arrowContinuous = "arrowContinuous",
    arrowCross = "arrowCross",
    arrowCrossOff = "arrowCrossOff",
    arrowDown = "arrowDown",
    arrowDownload = "arrowDownload",
    arrowForward = "arrowForward",
    arrowGoTo = "arrowGoTo",
    arrowInbound = "arrowInbound",
    arrowInboundError = "arrowInboundError",
    arrowInboundCaution = "arrowInboundCaution",
    arrowOutbound = "arrowOutbound",
    arrowOutboundError = "arrowOutboundError",
    arrowPopout = "arrowPopout",
    arrowRefresh = "arrowRefresh",
    arrowBackward = "arrowBackward",
    arrowBackwardAll = "arrowBackwardAll",
    arrowRedo = "arrowRedo",
    arrowReturn = "arrowReturn",
    arrowRight = "arrowRight",
    arrowSplit = "arrowSplit",
    arrowSwap = "arrowSwap",
    arrowSwitch = "arrowSwitch",
    arrowTime = "arrowTime",
    arrowUndo = "arrowUndo",
    arrowUp = "arrowUp",
    arrowUpload = "arrowUpload",
    ascending = "ascending",
    asterisk = "asterisk",
    attachment = "attachment",
    autoMatch = "autoMatch",
    badgeWarning = "badgeWarning",
    bill = "bill",
    billResend = "billResend",
    billScheduled = "billScheduled",
    billSplit = "billSplit",
    boxAdd = "boxAdd",
    boxArrowLeft = "boxArrowLeft",
    boxHide = "boxHide",
    boxFilled = "boxFilled",
    briefcaseAdd = "briefcaseAdd",
    briefcaseCashAdd = "briefcaseCashAdd",
    briefcaseView = "briefcaseView",
    brokerBadge = "brokerBadge",
    bulkAction = "bulkAction",
    bullseye = "bullseye",
    bypass = "bypass",
    calculator = "calculator",
    calendar = "calendar",
    calendar10 = "calendar10",
    calendar30 = "calendar30",
    calendarConfirmed = "calendarConfirmed",
    calendarDue = "calendarDue",
    calendarRecurring = "calendarRecurring",
    calendarScheduled = "calendarScheduled",
    cardCall = "cardCall",
    cardLog = "cardLog",
    caret = "caret",
    carrier = "carrier",
    carrierDelete = "carrierDelete",
    carrierCapacityAdd = "carrierCapacityAdd",
    carrierPhone = "carrierPhone",
    carrierPost = "carrierPost",
    carrierRates = "carrierRates",
    carrierSearch = "carrierSearch",
    cashAdd = "cashAdd",
    chat = "chat",
    chatComms = "chatComms",
    chatConfirm = "chatConfirm",
    chatConversation = "chatConversation",
    chatError = "chatError",
    chatCancel = "chatCancel",
    chatPhone = "chatPhone",
    chatRecurring = "chatRecurring",
    chatTyping = "chatTyping",
    chatUnread = "chatUnread",
    chatUser = "chatUser",
    check = "check",
    chevronDoubleRight = "chevronDoubleRight",
    chevronDown = "chevronDown",
    chevronLeft = "chevronLeft",
    chevronRight = "chevronRight",
    chevronUp = "chevronUp",
    circleAdd = "circleAdd",
    circleAddFilled = "circleAddFilled",
    circleArrowDownFilled = "circleArrowDownFilled",
    circleArrowDownLeft = "circleArrowDownLeft",
    circleArrowDownLeftFilled = "circleArrowDownLeftFilled",
    circleArrowRight = "circleArrowRight",
    circleArrowUpFilled = "circleArrowUpFilled",
    circleArrowUpperRight = "circleArrowUpperRight",
    circleArrowUpRight = "circleArrowUpRight",
    circleArrowUpRightFilled = "circleArrowUpRightFilled",
    circleCancel = "circleCancel",
    circleConfirm = "circleConfirm",
    circleConfirmFilled = "circleConfirmFilled",
    circleDelete = "circleDelete",
    circleDivided = "circleDivided",
    circleEmpty = "circleEmpty",
    circleError = "circleError",
    circleErrorFilled = "circleErrorFilled",
    circleFilled = "circleFilled",
    circleImport = "circleImport",
    circleInfo = "circleInfo",
    circleLink = "circleLink",
    circleQuestion = "circleQuestion",
    circleRadio = "circleRadio",
    circleRadioOff = "circleRadioOff",
    circleSplit = "circleSplit",
    circleTrailer = "circleTrailer",
    circleVoid = "circleVoid",
    classic = "classic",
    clipboard = "clipboard",
    clipboardCancelOrder = "clipboardCancelOrder",
    clipboardEmpty = "clipboardEmpty",
    clipboardLoadMatch = "clipboardLoadMatch",
    clipboardSearch = "clipboardSearch",
    clipboardUnbilledOrder = "clipboardUnbilledOrder",
    clock = "clock",
    close = "close",
    cloud = "cloud",
    cloudArrow = "cloudArrow",
    cloudFilled = "cloudFilled",
    coinStack = "coinStack",
    compactView = "compactView",
    component_checkboxChecked = "component/checkboxChecked",
    component_checkboxUnchecked = "component/checkboxUnchecked",
    component_radioOff = "component/radioOff",
    component_radioOn = "component/radioOn",
    copy = "copy",
    crossDock = "crossDock",
    dash = "dash",
    dataDownArrow = "dataDownArrow",
    delete = "delete",
    descending = "descending",
    document = "document",
    documentAdd = "documentAdd",
    documentBol = "documentBol",
    documentCancel = "documentCancel",
    documentCsvDownload = "documentCsvDownload",
    documentConfirm = "documentConfirm",
    documentCounter = "documentCounter",
    documentError = "documentError",
    documentExcel = "documentExcel",
    documentExcelDownload = "documentExcelDownload",
    documentInboundWarning = "documentInboundWarning",
    documentInboundError = "documentInboundError",
    documentOrderHistory = "documentOrderHistory",
    documentOrderHistoryError = "documentOrderHistoryError",
    documentOutbound = "documentOutbound",
    documentOutboundWarning = "documentOutboundWarning",
    documentOutboundError = "documentOutboundError",
    documentPdf = "documentPdf",
    documentProcessLog = "documentProcessLog",
    documentRadio = "documentRadio",
    documentRateOrder = "documentRateOrder",
    documentReport = "documentReport",
    documentSearch = "documentSearch",
    documentSettings = "documentSettings",
    documentSettlements = "documentSettlements",
    documentSettlementsUpload = "documentSettlementsUpload",
    documentTransferSettlements = "documentTransferSettlements",
    documentTransmission = "documentTransmission",
    documentUpload = "documentUpload",
    documentVersionLog = "documentVersionLog",
    documentView = "documentView",
    driver = "driver",
    driverAdd = "driverAdd",
    driverDelete = "driverDelete",
    drivers = "drivers",
    edit = "edit",
    editOff = "editOff",
    envelopeAdd = "envelopeAdd",
    envelopeMulti = "envelopeMulti",
    envelopePending = "envelopePending",
    envelopeRead = "envelopeRead",
    envelopeUnread = "envelopeUnread",
    exit = "exit",
    expand = "expand",
    feasibility = "feasibility",
    filter = "filter",
    fire = "fire",
    folder = "folder",
    form = "form",
    formEdit = "formEdit",
    fuelCard = "fuelCard",
    fuelCardActive = "fuelCardActive",
    fuelCardBlock = "fuelCardBlock",
    fuelCardDestroy = "fuelCardDestroy",
    fuelCoin = "fuelCoin",
    fuelSettings = "fuelSettings",
    globeUpdate = "globeUpdate",
    graphData = "graphData",
    graphLine = "graphLine",
    graphPie = "graphPie",
    hand = "hand",
    handCancel = "handCancel",
    handCash = "handCash",
    handCoin = "handCoin",
    handDelete = "handDelete",
    handOffer = "handOffer",
    handshake = "handshake",
    heart = "heart",
    hierarchy = "hierarchy",
    historyCalls = "historyCalls",
    historyEvents = "historyEvents",
    home = "home",
    image = "image",
    import = "import",
    inboxCancel = "inboxCancel",
    inboxCaution = "inboxCaution",
    inboxReplyCancel = "inboxReplyCancel",
    inboxReplyConfirmCancel = "inboxReplyConfirmCancel",
    inboxReplyConfirmError = "inboxReplyConfirmError",
    inboxReplyError = "inboxReplyError",
    inboxReplyErrorNeedsAtt = "inboxReplyErrorNeedsAtt",
    intercompany = "intercompany",
    intercompanyError = "intercompanyError",
    invoice = "invoice",
    key = "key",
    keyOff = "keyOff",
    laneHistory = "laneHistory",
    layout = "layout",
    letterCase = "letterCase",
    lightbulb = "lightbulb",
    lightningBolt = "lightningBolt",
    link = "link",
    linkBroken = "linkBroken",
    list = "list",
    listSearch = "listSearch",
    listStar = "listStar",
    loadboard = "loadboard",
    loadboardError = "loadboardError",
    loadboardPrice = "loadboardPrice",
    lockClosed = "lockClosed",
    lockOpen = "lockOpen",
    manifest = "manifest",
    map = "map",
    mapLocation = "mapLocation",
    mapLocationAdd = "mapLocationAdd",
    mapPin = "mapPin",
    mapPinArrowLeft = "mapPinArrowLeft",
    mapPinArrowRight = "mapPinArrowRight",
    mapPinFilled = "mapPinFilled",
    mapPinGoogle = "mapPinGoogle",
    mapPinLocate = "mapPinLocate",
    mapPinLocateMovement = "mapPinLocateMovement",
    mapPinTrackingLive = "mapPinTrackingLive",
    mapPinUser = "mapPinUser",
    maximize = "maximize",
    menuEllipsis = "menuEllipsis",
    menuHamburger = "menuHamburger",
    message = "message",
    messageError = "messageError",
    messageGroup = "messageGroup",
    messageLines = "messageLines",
    messageMoney = "messageMoney",
    minimize = "minimize",
    mobile = "mobile",
    mobileConfirm = "mobileConfirm",
    money = "money",
    moneyQuick = "moneyQuick",
    move = "move",
    multiple = "multiple",
    note = "note",
    noteAdd = "noteAdd",
    notification = "notification",
    notificationCount = "notificationCount",
    number = "number",
    oneToMany = "oneToMany",
    oneToOne = "oneToOne",
    package = "package",
    packageAdd = "packageAdd",
    packageConfirm = "packageConfirm",
    packageDelivered = "packageDelivered",
    packageDrop = "packageDrop",
    packageError = "packageError",
    packageErrorBottom = "packageErrorBottom",
    packageInbound = "packageInbound",
    packageInboundError = "packageInboundError",
    packageLocation = "packageLocation",
    packageOutbound = "packageOutbound",
    packageOutboundError = "packageOutboundError",
    packagePickup = "packagePickup",
    packageResend = "packageResend",
    packageSearch = "packageSearch",
    payee = "payee",
    personRunning = "personRunning",
    phone = "phone",
    print = "print",
    printAgain = "printAgain",
    printConfirmed = "printConfirmed",
    process = "process",
    progressbar = "progressbar",
    pushPin = "pushPin",
    puzzle = "puzzle",
    quickQuote = "quickQuote",
    radius = "radius",
    reorder = "reorder",
    resetPercent = "resetPercent",
    resetSettings = "resetSettings",
    reticle = "reticle",
    ribbon = "ribbon",
    ribbonConfirmed = "ribbonConfirmed",
    ribbonError = "ribbonError",
    ribbonWarning = "ribbonWarning",
    rocketshipOff = "rocketshipOff",
    rocketshipOn = "rocketshipOn",
    routeLate = "routeLate",
    save = "save",
    saveCancel = "saveCancel",
    saveDuplicate = "saveDuplicate",
    search = "search",
    searchOffer = "searchOffer",
    searchText = "searchText",
    seatbeltOff = "seatbeltOff",
    seatbeltOn = "seatbeltOn",
    selectAll = "selectAll",
    send = "send",
    sending = "sending",
    settings = "settings",
    share = "share",
    shieldCancel = "shieldCancel",
    shieldConfirm = "shieldConfirm",
    shieldWarning = "shieldWarning",
    shrink = "shrink",
    sort = "sort",
    spinner = "spinner",
    starFilled = "starFilled",
    steeringWheel = "steeringWheel",
    tab = "tab",
    tableAdd = "tableAdd",
    tableRowExpire = "tableRowExpire",
    tagPrice = "tagPrice",
    taxAdd = "taxAdd",
    terminalInfo = "terminalInfo",
    thermometer = "thermometer",
    thermometerError = "thermometerError",
    thermometerWarning = "thermometerWarning",
    thermostat = "thermostat",
    thumbsDown = "thumbsDown",
    thumbsUp = "thumbsUp",
    timer = "timer",
    timerCharging = "timerCharging",
    timerConfirm = "timerConfirm",
    timerError = "timerError",
    timerStart = "timerStart",
    trailer = "trailer",
    trailerLoaded = "trailerLoaded",
    trailerLocate = "trailerLocate",
    trailerNotLoaded = "trailerNotLoaded",
    truck = "truck",
    truckLate = "truckLate",
    user = "user",
    userFilled = "userFilled",
    userFilter = "userFilter",
    userFilterActive = "userFilterActive",
    userPayables = "userPayables",
    userThree = "userThree",
    userThreeBlueMiddle = "userThreeBlueMiddle",
    userTwoFilled = "userTwoFilled",
    viewProperties = "viewProperties",
    viewSplitHorizontal = "viewSplitHorizontal",
    viewTimeline = "viewTimeline",
    viewSplitVertical = "viewSplitVertical",
    visibleOff = "visibleOff",
    visible = "visible",
    warning = "warning",
    warningFilled = "warningFilled",
    waterfall = "waterfall",
    windowOverlapping = "windowOverlapping",
    wrench = "wrench",
    ysplit = "ysplit",
    ysplitComplete = "ysplitComplete",
    ysplitDropPick = "ysplitDropPick",
    ysplitPick = "ysplitPick",
    zipCode = "zipCode",
    zMit = "zMit",
    zMitDelete = "zMitDelete",
    zMitTransmitted = "zMitTransmitted",
    zMitConfirm = "zMitConfirm",
    zMitCancel = "zMitCancel",

    // Images specific to the web portals; these shouldn't be used elsewhere
    boxPalletFacingRight = "boxPalletFacingRight",
    dryVanLeftFacing = "dryVanLeftFacing",
    dryVanWithArrowRight = "dryVanWithArrowRight",
    ftlDryVanOrder = "ftlDryVanOrder",
    ftlDryVanQuote = "ftlDryVanQuote",
    ltlPalletOrder = "ltlPalletOrder",
    ltlPalletQuote = "ltlPalletQuote",

    // Company Logos
    datLogo = "datLogo",
    highway_icon = "highway_icon",
    highwayEmailVerificationLogo = "highwayEmailVerificationLogo",
    highwayError = "highwayError",
    isoMarkPurple = "isoMarkPurple",
    mpactLogoDark = "mpactLogoDark",
    truckstopLogo = "truckstopLogo",
    triumphPayIcon ="triumphPayIcon",

    // Component images used in the UI Designer
    // These reside in the designer folder and are excluded from the selector in the UI Designer/Tailor
    designer_button = "designer/button",
    designer_chart = "designer/chart",
    designer_checkbox = "designer/checkbox",
    designer_dataheader = "designer/dataheader",
    designer_datasource = "designer/datasource",
    designer_horizontalspacer = "designer/horizontalspacer",
    designer_iframe = "designer/iframe",
    designer_label = "designer/label",
    designer_layoutheader = "designer/layoutheader",
    designer_location = "designer/location",
    designer_numbereditor = "designer/numbereditor",
    designer_panel = "designer/panel",
    designer_radio = "designer/radio",
    designer_radiobox = "designer/radiobox",
    designer_repeater = "designer/repeater",
    designer_savebutton = "designer/savebutton",
    designer_searchbutton = "designer/searchbutton",
    designer_splitter = "designer/splitter",
    designer_starrating = "designer/starrating",
    designer_stepper = "designer/stepper",
    designer_switch = "designer/switch",
    designer_table = "designer/table",
    designer_tabset = "designer/tabset",
    designer_textbox = "designer/textbox",
    designer_tree = "designer/tree",
    designer_widget = "designer/widget",

    // Images used in the Model Designer
    // These reside in the designer folder and are excluded from the selector in the UI Designer/Tailor
    designer_innerJoin = "designer/innerJoin",
    designer_outerJoin = "designer/outerJoin",

    // Utility images (used in internal tools)
    // These reside in the utility folder and are excluded from the selector in the UI Designer/Tailor
    utility_apiDot = "utility/apiDot",
    utility_bracketsCode = "utility/bracketsCode",
    utility_bracketsCurly = "utility/bracketsCurly",
    utility_brokenPallet = "utility/brokenPallet",
    utility_connect = "utility/connect",
    utility_documentWsdl = "utility/documentWsdl",
    utility_fan = "utility/fan",
    utility_openapi = "utility/openapi",
    utility_postman = "utility/postman",
    utility_raml = "utility/raml",
    utility_thread = "utility/thread",
    utility_wizard = "utility/wizard"
}
